/* ---------------------------------
GLOBAL FUNCTIONS
---------------------------------*/

//Con esta función pasamos 650012 a $6.500,12. Valores de precio y de IVA.
function getPriceFromNumber(value, type = "default") {
  // Redondear hacia abajo para obtener un número entero
  let roundedValue = Math.floor(value).toString();

  let formattedValue = roundedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  // Si el tipo es default, añadir el símbolo de $
  return type === "default" ? `$${formattedValue}` : formattedValue;
}

/* ---------------------------------
FILTER MENU
---------------------------------*/

class FilterMenu extends HTMLElement {
  constructor() {
    super();
    this.toggleBtn = document.querySelector("#filter-menu-btn");

    //Los inputs de precio
    this.minPriceInput = this.querySelector('input[name="price_min"]');
    this.maxPriceInput = this.querySelector('input[name="price_max"]');

    //Los tags que muestran el valor seleccionado
    this.minPriceFilterTag = this.querySelector("#minPriceFilterTag");
    this.maxPriceFilterTag = this.querySelector("#maxPriceFilterTag");

    //Precio menor y mayor de la colección
    this.minPrice = this.getAttribute("min");
    this.maxPrice = this.getAttribute("max");

    //Los forms
    this.colorForm = this.querySelector(".color-form");
    this.availForm = this.querySelector(".avail-form");
    this.sortForm = this.querySelector(".sort-form");

    this.toggleStatus = this.toggleStatus.bind(this);
    this.detectOutsideClick = this.detectOutsideClick.bind(this);
    this.filterProducts = this.filterProducts.bind(this);
    this.updatePriceUi = this.updatePriceUi.bind(this);

    //Para detectar cuando se abra el menu
    this.toggleBtn.addEventListener("click", this.toggleStatus);

    //Los eventos cuando cambia el filtro de precio
    this.maxPriceInput?.addEventListener("change", () =>
      this.filterProducts("maxPrice")
    );
    this.minPriceInput?.addEventListener("change", () =>
      this.filterProducts("minPrice")
    );

    //El evento cuando cambia el filtro de color
    this.colorForm?.addEventListener("change", () =>
      this.filterProducts("color")
    );

    //El evento cuando cambia el filtro de disponibilidad
    this.availForm?.addEventListener("change", () =>
      this.filterProducts("available")
    );

    //El evento cuando cambia el sorting
    this.sortForm?.addEventListener("change", () =>
      this.filterProducts("sort")
    );

    document.addEventListener("DOMContentLoaded", this.updatePriceUi);
  }

  filterProducts(filterChanged) {
    // Crear una instancia del objeto URL basado en la URL actual
    const url = new URL(window.location.href);

    switch (filterChanged) {
      case "maxPrice":
        //En caso de que se establezca un limite mayor menor al limite inferior, no se podría
        if (
          Number(this.maxPriceInput.value) < Number(this.minPriceInput.value)
        ) {
          this.maxPriceFilterTag.innerText = getPriceFromNumber(
            Number(this.minPriceInput.value)
          );
          this.maxPriceInput.value = this.minPriceInput.value;
        } else {
          this.maxPriceFilterTag.innerText = getPriceFromNumber(
            Number(this.maxPriceInput.value)
          );
        }

        // Si el valor de maxPriceInput es igual a su valor máximo, elimina el filtro del URL
        if (
          Number(this.maxPriceInput.value) === Number(this.maxPriceInput.max)
        ) {
          url.searchParams.delete("filter.v.price.lte");
        } else {
          url.searchParams.set("filter.v.price.lte", this.maxPriceInput.value);
        }
        break;

      case "minPrice":
        //En caso de que se establezca un limite menor mayor al limite superior, no se podría
        if (
          Number(this.minPriceInput.value) > Number(this.maxPriceInput.value)
        ) {
          this.minPriceFilterTag.innerText = getPriceFromNumber(
            Number(this.maxPriceInput.value)
          );
          this.minPriceInput.value = this.maxPriceInput.value;
        } else {
          this.minPriceFilterTag.innerText = getPriceFromNumber(
            Number(this.minPriceInput.value)
          );
        }

        // Si el valor de minPriceInput es igual a 0, elimina el filtro del URL
        if (Number(this.minPriceInput.value) === 0) {
          url.searchParams.delete("filter.v.price.gte");
        } else {
          url.searchParams.set("filter.v.price.gte", this.minPriceInput.value);
        }
        break;

      case "color":
        var filterData = new FormData(this.colorForm);
        var filterParams = new URLSearchParams(filterData);

        // Eliminar todos los parámetros de color existentes antes de acumular nuevos valores
        url.searchParams.delete("filter.v.option.color");

        // Si filterParams no está vacío, acumulamos los valores de color
        if (filterParams.toString()) {
          for (const [key, value] of filterParams) {
            url.searchParams.append("filter.v.option.color", value);
          }
        } else {
          // Si filterParams está vacío, asegúrate de eliminar el parámetro 'filter.v.option.color'
          url.searchParams.delete("filter.v.option.color");
        }
        break;

      case "available":
        var filterData = new FormData(this.availForm);
        var filterParams = new URLSearchParams(filterData);

        // Eliminar todos los parámetros de disppnibilidad existentes antes de acumular nuevos valores
        url.searchParams.delete("filter.v.availability");

        // Si filterParams no está vacío, acumulamos los valores de disppnibilidad
        if (filterParams.toString()) {
          for (const [key, value] of filterParams) {
            url.searchParams.append("filter.v.availability", value);
          }
        } else {
          // Si filterParams está vacío, asegúrate de eliminar el parámetro 'filter.v.availability'
          url.searchParams.delete("filter.v.availability");
        }
        break;

      case "sort":
        var filterData = new FormData(this.sortForm);
        const formObj = Object.fromEntries(filterData);

        // Eliminar todos los parámetros de sorteo existentes antes de acumular nuevos valores
        url.searchParams.delete("sort_by");

        if (formObj["sort_by"]) {
          url.searchParams.append("sort_by", formObj["sort_by"]);
        } else {
          // Si filterParams está vacío, asegúrate de eliminar el parámetro 'sort_by'
          url.searchParams.delete("sort_by");
        }

        break;
    }

    // Verifica si existe el parámetro "page" y elimínalo
    if (url.searchParams.has("page")) {
      url.searchParams.delete("page");
    }

    //En caso de que existan

    //Ej:https://dotacocol.myshopify.com/collections/gorras?filter.v.price.lte=46739
    const stringedUrl = url.toString();
    //Ejecutamos la llamada AJAX
    fetch(stringedUrl)
      .then((response) => response.text())
      .then((data) => {
        // Parse the response HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");

        // Replace the product grid
        const newProductGrid = doc.getElementById("ProductGrid");

        document.getElementById("ProductGrid").innerHTML =
          newProductGrid.innerHTML;

        if (newProductGrid.innerHTML.trim() !== "") {
          // Replace the pagination

          const newUpperPagination = doc.querySelector(".upper-pagination");
          const upperPagination = document.querySelector(".upper-pagination");
          upperPagination.innerHTML = newUpperPagination.innerHTML;
          if (upperPagination.classList.contains("hidden")) {
            upperPagination.classList.remove("hidden");
          }

          const newLowerPagination = doc.querySelector(".lower-pagination");
          const lowerPagination = document.querySelector(".lower-pagination");
          lowerPagination.innerHTML = newLowerPagination.innerHTML;
          if (lowerPagination.classList.contains("hidden")) {
            lowerPagination.classList.remove("hidden");
          }
        } else {
          const upperPagination = document.querySelector(".upper-pagination");
          const lowerPagination = document.querySelector(".lower-pagination");

          if (!upperPagination.classList.contains("hidden")) {
            upperPagination.classList.add("hidden");
          }
          if (!lowerPagination.classList.contains("hidden")) {
            lowerPagination.classList.add("hidden");
          }
        }

        //Actualizamos el JS para elegir variantes
        this.dispatchEvent(
          new CustomEvent("updateVariantPicker", {
            bubbles: true,
          })
        );
      })
      .catch((error) => {
        console.error("Error updating collection:", error);
      });

    //Navega al nuevo URL
    history.pushState({}, "", stringedUrl);
  }

  updatePriceUi() {
    if (this.maxPriceInput && this.minPriceInput) {
      // Crear un objeto URL a partir del string
      const parsedUrl = new URL(window.location.href);

      // Obtener los valores de los searchParams para los precios
      const priceGteUrl = parsedUrl.searchParams.get("filter.v.price.gte");
      const priceLteUrl = parsedUrl.searchParams.get("filter.v.price.lte");

      const formattedPriceGteUrl = priceGteUrl ? Number(priceGteUrl) : null;
      const formattedPriceLteUrl = priceLteUrl ? Number(priceLteUrl) : null;

      // Extraer los valores de localStorage
      const maxPriceLocalStorage = localStorage.getItem("max_price");

      // Mostrar valores de localStorage en la console

      if (formattedPriceGteUrl) {
        this.minPriceInput.max = Number(maxPriceLocalStorage);
        this.minPriceInput.value = formattedPriceGteUrl;
        this.minPriceFilterTag.innerText =
          getPriceFromNumber(formattedPriceGteUrl);
      } else {
        this.minPriceInput.max = Number(maxPriceLocalStorage);
        this.minPriceInput.value = 0;

        this.minPriceFilterTag.innerText = getPriceFromNumber(0);
      }

      if (formattedPriceLteUrl) {
        this.maxPriceInput.max = Number(maxPriceLocalStorage);
        this.maxPriceInput.value = formattedPriceLteUrl;
        this.maxPriceFilterTag.innerText =
          getPriceFromNumber(formattedPriceLteUrl);
      } else {
        this.maxPriceInput.max = Number(maxPriceLocalStorage);
        this.maxPriceInput.value = Number(maxPriceLocalStorage);

        this.maxPriceFilterTag.innerText = getPriceFromNumber(
          Number(maxPriceLocalStorage)
        );
      }
    }
  }

  toggleStatus() {
    const status = this.getAttribute("status");
    if (status === "close") {
      this.setAttribute("status", "open");
    } else {
      this.setAttribute("status", "close");
    }
  }

  static get observedAttributes() {
    return ["status"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "status") {
      if (newValue === "open") {
        this.classList.remove("hidden");
        setTimeout(() => {
          this.classList.add("show");
        }, 50);
        document.addEventListener("click", this.detectOutsideClick);
      } else if (newValue === "close") {
        this.classList.remove("show");
        setTimeout(() => {
          this.classList.add("hidden");
        }, 50);
        document.removeEventListener("click", this.detectOutsideClick);
      }
    }
  }

  detectOutsideClick = (e) => {
    // Obtiene la posición X e Y donde se hizo clic
    const x = e.clientX;
    const y = e.clientY;

    // Selecciona todos los elementos en esa posición
    const elements = document.elementsFromPoint(x, y);

    // Itera sobre los elementos y haz lo que necesites con ellos

    const isMenuOpened = elements?.some(
      (el) => el?.id === `filter-menu-${this.dataset.id}`
    );
    const isBtnPresent = elements?.some((el) => el?.id === "filter-menu-btn");

    if (!isMenuOpened && !isBtnPresent) {
      const status = this.getAttribute("status");
      if (status === "open") {
        this.setAttribute("status", "close");
      }
    }
  };
}

customElements.define("filter-menu", FilterMenu);
